var map = {
	"./angular.svg": "9451",
	"./book.svg": "a337",
	"./bootstrap.svg": "2ea3",
	"./brush.svg": "815f",
	"./crown.svg": "bec8",
	"./figma.svg": "7472",
	"./imdb.svg": "fdfc",
	"./parachute.svg": "666b",
	"./react.svg": "f4d6",
	"./rocket.svg": "df02",
	"./speaker.svg": "1535",
	"./star.svg": "0a83",
	"./tiktok-brands.svg": "cbf9",
	"./toolbox.svg": "40d5",
	"./vuejs.svg": "57c1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5981";